import { Ability } from '@casl/ability';

export const initialAbility = [
  {
    action: 'read',
    subject: 'Public',
  },
];

// Seed CASL with the minimal Public ability only. Real abilities are derived from backend scopes
// by stores/auth.js (syncAbilities) after session restore, which the router guard awaits before any
// decision — so we never seed from localStorage (it's user-editable → a client-side privilege bump;
// real authorization is server-side regardless).
export default new Ability(initialAbility);
